var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locale-switcher"},[_c('v-select',{attrs:{"items":_vm.locales,"item-text":"name","item-value":"code","return-object":"","placeholder":_vm.$t('language')},on:{"change":_vm.changeLocale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }